export enum CollectGroupType {
    Church,
    Campaign,
    Artists,
    Charities,
    Unknown,
    Demo,
    Debug
}